import { render, staticRenderFns } from "./fechasPago.vue?vue&type=template&id=72a6ef78&scoped=true"
import script from "./fechasPago.vue?vue&type=script&lang=js"
export * from "./fechasPago.vue?vue&type=script&lang=js"
import style0 from "./fechasPago.vue?vue&type=style&index=0&id=72a6ef78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a6ef78",
  null
  
)

export default component.exports